<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
                this.$t('report.company_dashboard.reports')
              }}
            </span>
          </li>
          <li>{{ $t('general.certification_reports') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t('general.certification_reports') }} </span>
        </h2>
      </div>
      <div class="section-header-right">
        <button :disabled="isDisabledBtn" class="btn btn-default" @click="bulkDownloadCertifications">
          <i class="uil-folder-download"></i> {{ $t('certificate.export_pdf_btn') }}
        </button>
      </div>
    </div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                     class="uk-search-input shadow-0 uk-form-small" type="search"/>
            </div>
          </div>
          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
               href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>
            <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
               href="javascript:void(0)">
              <i class="uil-filter"></i>
            </a>
            <UserFilter class="certificates-user-filter" :assignmentList="assignmentList" :contentList="contentList" :contentLoading="contentLoading"
                        :isUserActive="true" :reportAssignment="true" :showContentFilter="true"
                        @getFilter="getFilter($event)"/>

            <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
                                   @download="exportCertificates"/>

          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col">{{ $t("users.photo") }}</th>
              <th scope="col">ID</th>
              <th scope="col">{{ $t('general.certificate_number') }}</th>
              <th scope="col">{{ $t('certificate.name') }}</th>
              <th scope="col">{{ $t('certificate.content_title') }}</th>
              <th scope="col">{{ $t('general.first_name_and_last_name') }}</th>
              <th scope="col">{{ $t("users.user_email") }}</th>
              <th scope="col">{{ $t('general.user_status') }}</th>
              <th scope="col">{{ $t('general.register_number') }}</th>
              <th scope="col">{{ $t('general.assignment_name') }}</th>
              <th scope="col">{{ $t('general.certificate_received_date') }}</th>
              <th scope="col">{{ $t('general.certificate_end_date') }}</th>
              <th scope="col">{{ $t('general.remaining_time') }}</th>
              <th scope="col">{{ $t('general.transactions') }}</th>
            </tr>
            </thead>
            <tbody class="list">
            <template v-for="item in formattedItems">
              <tr>
                <th scope="row">
                  <div class="media align-items-center">
                    <div>
                      <div class="avatar-parent-child" style="width: max-content">
                        <AvatarOrIcon :alt="item.name" :size-px="32" :src="item.photo_link"/>
                      </div>
                    </div>
                  </div>
                </th>
                <td>{{ item.id }}</td>
                <td>{{ item.unique_certificate_number }}</td>
                <td>{{ item.certificate_name }}</td>
                <td>{{ item.contentable_title }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.registration_number }}</td>
                <td>{{ item.assignmentable_name }}</td>
                <td>{{ item.certificate_start_date }}</td>
                <td>{{ item.certificate_end_date }}</td>
                <td>{{ item.remaining_day }}</td>
                <td class="transactions-btn">
                  <button :disabled="!item.certificate_download_link || downloadingCertId === item.cert_id"
                          :uk-tooltip="$t('general.download')" class="download-btn" @click="downloadCertificate(item)">
                    <i class="uil-download-alt"></i>
                  </button>
                  <button :disabled="item.is_assigned_content" :uk-tooltip="$t('general.delete')" class="delete-btn"
                          @click="deleteCertificate(item)">
                    <i class="uil-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  GET_ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment";
import {
  backendHttpClient,
  publicHttpClient,
} from "@/core/services/api.service";
import Pagination from "@/assets/components/Pagination";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import UserFilter from "@/view/company/User/Filter";

const _MODULE_NAME = MODULE_NAME;
import { confirmDialogDelete } from "@/utils/confirmDialog";
import { showSuccess, showError } from "@/utils/alertUtils";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import Swal from "sweetalert2";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const {
  resolveBackendUrl,
  resolvePublicUrl,
} = require("@/core/services/api-url-policy");

export default {
  name: "ReportCertificates",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: { ExcelDownloadButton, Pagination, DefaultLoading, UserFilter, AvatarOrIcon },
  data() {
    return {
      pagination: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      sort: "id",
      order: "desc",
      filter: {
        search: null,
      },
      assignmentList: [],
      contentList: [],
      assignmentLoading: false,
      contentLoading: false,
      keepFilter: null,
      isReportDownloading: false,
      isDisabledBtn: false,
      downloadingCertId: null,
    };
  },
  computed: {
    user_loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    exportCertificates() {
      if (this.isReportDownloading) {
        return;
      }

      let self = this;
      this.isReportDownloading = true;
      const params = this.getReportFilters({
        report: Math.random() * 9999999,
      });
      backendHttpClient
          .get(process.env.VUE_APP_BACKEND_APP_URL +
              "/api/report/export/certificates", {
            responseType: "blob",
            params,
            headers: this.apiHeaders,
          })
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            let day = moment().format("YYYYMMDDHHMMSS");
            fileLink.setAttribute("download", "certificate_report_list_" + day + ".xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
          })
          .finally(() => {
            this.isReportDownloading = false;
          });
    },
    filterResult(filter = null) {
      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, yenileme)
      // getReportFilters keepFilter'daki son filtreyle isteği kurar
      if (filter) {
        this.keepFilter = filter;
      }
      let filters = this.getReportFilters({
        page: this.page,
        perPage: this.per_page,
      });

      store
          .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
            url: "api/report/certificates",
            filters: filters,
          })
          .then((response) => {
            if (response?.status) {
              let results = [];
              let items = response.data;
              this.pagination = items;
              items.data.forEach((item) => {
                let remaining_day = null;
                const isExpireable = item.certificate.expireable == 1;
                if (isExpireable && item.certificate.end_date) {
                  let start = moment().format("YYYY-MM-DD");
                  let end = moment(item.certificate.end_date, "YYYY-MM-DD");
                  remaining_day = moment.duration(end.diff(start)).asDays();
                }
                results.push({
                  id: item.user?.id,
                  cert_id: item.id,
                  certificate_download_link: item.certificate_download_link ?? null,
                  name: item.user?.fullname,
                  email: item.user?.email,
                  status: item.user?.status_id == 0 ? this.$t("general.passive") : this.$t("general.active"),
                  registration_number: item.user?.registration_number ?? "-",
                  photo_link: item.user?.photo_link,
                  certificate_start_date: item.created_at
                      ? moment(item.created_at).format("DD/MM/YYYY")
                      : "-",
                  certificate_end_date: isExpireable && item.certificate.end_date
                      ? moment(item.certificate.end_date).format("DD/MM/YYYY")
                      : this.$t("general.unlimited_certificate"),
                  remaining_day:
                      remaining_day !== null
                          ? remaining_day > 0
                              ? remaining_day + " " + this.$t("general.day_unit")
                              : this.$t("general.certificate_expired")
                          : "-",
                  content_title: item.last_content
                      ? item.last_content.title
                      : "-",
                  assignmentable_name: item.assignmentable
                      ? item.assignmentable.name
                      : "-",
                  // contentable_title: item.contentable
                  //     ? item.contentable.title
                  //     : "-",
                  contentable_title: item.content_title || item.training_name || "-",
                  unique_certificate_number: item.unique_certificate_id
                      ? item.unique_certificate_id
                      : "-",
                  certificate_name: item.certificate.name ?? "-",
                  is_assigned_content: !![item.assignment_name].find(val => val && val !== '-')
                });
              });
              this.formattedItems = results;
            } else {
              this.formattedItems = [];
              this.pagination = null;
            }
          })
          .catch((error) => {
            this.formattedItems = [];
            this.pagination = null;
            const message = error?.response?.data?.message ||
                this.$t("general.load_failed");
            showError(message);
          });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.order = order;
      this.sort = sort;
      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    getFilter(value) {
      this.page = 1;
      this.filterResult(value);
    },
    async deleteCertificate(item) {

      if (item.is_assigned_content) {
        showError(this.$t('general.certificate_has_assigned_cannot_delete'));
        return
      }

      try {
        const isConfirmed = await confirmDialogDelete({ context: this });

        if (isConfirmed) {
          await backendHttpClient.delete(`api/user-certificate/${item.cert_id}`);

          showSuccess(this.$t('general.delete_successfully_done'));

          this.filterResult();
        }
      } catch (error) {
        this.$store.commit(_MODULE_NAME + "/" + LOADING, false);
        showError(error.response?.data?.message || this.$t('general.delete_error'));
        console.error('Delete error:', error);
      }
    },
    bulkDownloadCertifications() {
      this.isDisabledBtn = true;
      const params = this.getReportFilters({
        report: Math.random() * 9999999,
      });

      backendHttpClient
          .get(process.env.VUE_APP_BACKEND_APP_URL + "/api/report/export/certificates/pdf", {
            params,
          })
          .then(() => {
            Swal.fire({
              text: this.$t('certificate.export_pdf'),
              icon: "success",
              confirmButtonText: this.$t('general.ok'),
              confirmButtonColor: "#ae71ff",
            });
          }).finally(() => {
        this.isDisabledBtn = false;
      });
    },

    resolveDownloadUrl(link) {
      if (!link) return null;
      const backendBaseUrl = process.env.VUE_APP_BACKEND_APP_URL;

      try {
        return resolveBackendUrl(link, backendBaseUrl);
      } catch (backendError) {
        try {
          return resolvePublicUrl(link);
        } catch (publicError) {
          return null;
        }
      }
    },

    isBackendDownloadUrl(url) {
      try {
        resolveBackendUrl(url, process.env.VUE_APP_BACKEND_APP_URL);
        return true;
      } catch (error) {
        return false;
      }
    },

    async downloadCertificate(item) {
      const url = this.resolveDownloadUrl(item?.certificate_download_link);
      if (!url) {
        showError(this.$t("general.download_error"));
        return;
      }

      const isStorage = url.includes("/storage/") || url.endsWith(".pdf");

      if (isStorage) {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        a.remove();
        return;
      }

      this.downloadingCertId = item.cert_id;
      try {
        const requestClient = this.isBackendDownloadUrl(url)
            ? backendHttpClient
            : publicHttpClient;
        const res = await requestClient.get(url, {
          responseType: "blob",
        });
        const fileURL = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = fileURL;
        a.setAttribute("download", `certificate_${item.cert_id}.pdf`);
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(fileURL);
      } finally {
        this.downloadingCertId = null;
      }
    },

    toIdArray(val) {
      if (!val) return [];
      const arr = Array.isArray(val) ? val : [val];
      return arr
          .map(v => (v && typeof v === "object") ? v.id : v)
          .filter(v => v !== null && v !== undefined && v !== "" && v !== "all");
    },

    applyUserFilterToParams(params, filterObj) {
      const userIds = this.toIdArray(filterObj?.user_id ?? filterObj?.user_ids);
      if (userIds.length) {
        params.user_ids = JSON.stringify(userIds);
        delete params.user_id;
      } else {
        delete params.user_ids;
        delete params.user_id;
      }
    },

    applyIdFilterWithFallback(params, pluralKey, values) {
      if (!values || values.length === 0) {
        delete params[pluralKey];
        if (pluralKey === "assignment_ids") {
          delete params.assignment_id;
        }
        if (pluralKey === "content_ids") {
          delete params.content_id;
        }
        return;
      }

      params[pluralKey] = JSON.stringify(values);
      if (pluralKey === "assignment_ids") delete params.assignment_id;
      if (pluralKey === "content_ids") delete params.content_id;
    },
    getReportFilters({ page, perPage, report = null } = {}) {
      let filters = {
        like: this.filter.search,
        sort: this.sort,
        order: this.order,
      };

      if (page !== undefined && page !== null) {
        filters.page = page;
      }
      if (perPage !== undefined && perPage !== null) {
        filters.per_page = perPage;
      }
      if (report !== null) {
        filters.report = report;
      }

      const f = this.keepFilter;
      if (f) {
        if (f.company_id) filters.company_id = f.company_id;

        this.applyUserFilterToParams(filters, f);

        ["branch_id", "department_id", "region_id", "title_id", "position_id", "corporate_id", "group_id"].forEach((k) => {
          const ids = this.toIdArray(f[k]);
          if (ids.length) filters[k] = JSON.stringify(ids);
        });

        const assignmentIds = this.toIdArray(f.assignment_ids ?? f.assignment_id);
        this.applyIdFilterWithFallback(filters, "assignment_ids", assignmentIds);

        const contentIds = this.toIdArray(f.content_ids);
        this.applyIdFilterWithFallback(filters, "content_ids", contentIds);

        if (f.from_date) filters.from_date = f.from_date;
        if (f.to_date) filters.to_date = f.to_date;
      }

      return filters;
    },
    getReportLookupData(responseData) {
      if (!responseData) return [];
      if (Array.isArray(responseData)) return responseData;
      if (Array.isArray(responseData.data)) return responseData.data;
      return [];
    },
    getAssignments() {
      this.assignmentLoading = true;
      const filters = {
        sort: "id",
        order: "desc",
      };

      store.dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
        url: "api/report/certificate-assignments",
        filters,
      }).then((response) => {
        const results = [{
          id: "all",
          name: this.$t("general.all"),
        }];

        if (response && response.status) {
          const items = this.getReportLookupData(response.data);
          items.forEach((item) => {
            results.push({
              id: item.id,
              name: item.full_name || item.name,
              order_number: item.order_number,
            });
          });
        }

        this.assignmentList = results;
      }).finally(() => {
        this.assignmentLoading = false;
      });
    },
    getContents() {
      this.contentLoading = true;
      const filters = {
        sort: "desc",
        order_by: "id",
        program: true,
        sections: false,
        all: true,
      };

      store.dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
        url: "api/report/certificate-contents",
        filters,
      }).then((response) => {
        const results = [{
          id: "all",
          name: this.$t("general.all"),
        }];

        if (response && response.status) {
          const items = this.getReportLookupData(response.data);
          items.forEach((item) => {
            results.push({
              id: item.id,
              name: item.title && item.name ? `${item.title} - ${item.name}` : (item.title || item.name || item.full_name || ""),
            });
          });
        }

        this.contentList = results;
      }).finally(() => {
        this.contentLoading = false;
      });
    },
  },
  async mounted() {
    this.getAssignments();
    this.getContents();

    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin verisi gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.filterResult();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function () {
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
.certificates-user-filter ::v-deep .user-status-filter {
  display: none;
}

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}

/* Modern Delete Button Styling */
.transactions-btn {
  display: flex;
  gap: 8px;
  align-items: center;
}

.download-btn {
  background: linear-gradient(135deg, #6bc4ff 0%, #4a90e2 100%);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  padding: 4px 9px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(107, 196, 255, 0.2);
  position: relative;
  overflow: hidden;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}

.download-btn:hover {
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.35);
  background: linear-gradient(135deg, #58b6f5 0%, #2e7cc6 100%);
}

.download-btn:hover::before {
  left: 100%;
}

.download-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
}

.download-btn i {
  font-size: 16px;
  transition: transform 0.2s ease;
  color: white !important;
}

.download-btn:hover i {
  transform: scale(1.1);
}

.download-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.3);
}

.download-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.download-btn:disabled:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
}

.delete-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  padding: 4px 9px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);
  position: relative;
  overflow: hidden;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}

.delete-btn:hover {
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
  background: linear-gradient(135deg, #ff5252 0%, #d32f2f 100%);
}

.delete-btn:hover::before {
  left: 100%;
}

.delete-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.delete-btn i {
  font-size: 16px;
  transition: transform 0.2s ease;
  color: white !important;
}

.delete-btn:hover i {
  transform: scale(1.1);
}

/* Responsive design */
@media (max-width: 768px) {
  .delete-btn {
    padding: 6px 10px;
    min-width: 32px;
    height: 32px;
  }

  .delete-btn i {
    font-size: 14px;
  }
}

/* Focus state for accessibility */
.delete-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.3);
}

/* Disabled state */
.delete-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.delete-btn:disabled:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);
}
</style>
